import { TLegacyDriver } from "../api/types/Driver";

export const driverDisplayName = (driver: TLegacyDriver) => {
  return driver.driverid; // !!driver?.displayname ? driver.displayname : driver.driverid;
};
export const driverDisplayNameForAssetAdmin = (driver: TLegacyDriver) => {
  return !!driver?.displayname ? driver.displayname : driver.driverid;
};
